module.exports = __webpack_public_path__ + "img/art3-img1.82b305b4.jpeg";